import { render, staticRenderFns } from "./JbManCorretivaSubGrupo.vue?vue&type=template&id=1fd2c5d9&"
import script from "./JbManCorretivaSubGrupo.vue?vue&type=script&lang=js&"
export * from "./JbManCorretivaSubGrupo.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./JbManCorretivaSubGrupo.vue?vue&type=style&index=1&id=1fd2c5d9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports